import { SurveyAnswersNode } from "./survey-answers-node";

import type { LexicalNode } from "lexical";

export function $isSurveyAnswersNode(
  node: LexicalNode | null | undefined,
): node is SurveyAnswersNode {
  return node instanceof SurveyAnswersNode;
}
